import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';

const BurgerMenu = ({ onClick, isToggled }) => {
  const variant = isToggled ? 'opened' : 'closed';
  const width = 20;
  const height = 20;
  const top = {
    closed: {
      rotate: 0,
      translateY: 0,
    },
    opened: {
      rotate: 45,
      translateY: 2,
      originX: '3px 0px',
    },
  };
  const bottom = {
    closed: {
      rotate: 0,
      translateY: 0,
    },
    opened: {
      rotate: -45,
      translateY: -2,
      originX: '3px 4px',
    },
  };
  const lineProps = {
    stroke: '#fff',
    strokeWidth: 1.5,
    vectorEffect: 'non-scaling-stroke',
    initial: 'closed',
    animate: variant,
    transition: null,
  };
  const unitHeight = 6;
  const unitWidth = (unitHeight * width) / height;

  return (
    <button
      type="button"
      className="absolute bottom-0 right-5 top-0 z-[999999] block lg:hidden"
      onClick={onClick}
    >
      <motion.svg
        viewBox={`0 0 ${unitWidth} ${unitHeight}`}
        overflow="visible"
        preserveAspectRatio="none"
        width={width}
        height={height}
      >
        <motion.line x1="0" x2={unitWidth} y1="0" y2="0" variants={top} {...lineProps} />
        <motion.line x1="0" x2={unitWidth} y1="4" y2="4" variants={bottom} {...lineProps} />
      </motion.svg>
    </button>
  );
};

BurgerMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
  isToggled: PropTypes.bool.isRequired,
};

export default BurgerMenu;
